const $ = window.jQuery;

export default {
  init() {
    // JavaScript to be fired on the CES 2016 page
    $('#particles-ces').particleground({
      dotColor: 'rgba(0,119, 2238, .7 )',
      lineColor: 'rgba(0,119, 2238, .5 )',
      particleRadius: 4,
      lineWidth: 1,
      direction: 'up',
      proximity: 150,
    });
  },
  finalize() {},
};
